import { zfUtils } from "./zf_utils";
import { zfcc } from "./zfc_contact";
import { zfcgac } from "./zfc_gallery";
import { zfcgs } from "./zfc_general_slider";
import { zfcfsv } from "./zfc_video";
export class zfcacc {
    static before(target) {
        if (target.closest(".zfcacc-accordion-disabled").length) {
            return false;
        }
        target.siblings(".zfcacc-toggled").each(function () {
            this.slideClose();
        });
        return true;
    }
    static addSlideFunction() {
        var that = $(this), thatThis = this;
        this.slideClose = function (cb) {
            if (zfcacc.before(that)) {
                that.removeClass("zfcacc-toggled");
                that.children(".zfcacc-accordion-section-content").slideUp(function () {
                    if (cb) {
                        cb();
                    }
                });
            }
            else if (cb) {
                cb();
            }
        };
        this.slideOpen = function (cb) {
            if (zfcacc.before(that)) {
                that.addClass("zfcacc-toggled");
                that
                    .children(".zfcacc-accordion-section-content")
                    .slideDown(function () {
                    if (cb) {
                        cb();
                    }
                    zfUtils.checkLoadOnScroll();
                    window.location.hash = that.attr("id");
                });
            }
            else if (cb) {
                cb();
            }
        };
        this.triggerSlide = function (cb) {
            if (zfcacc.before(that)) {
                if (that.hasClass("zfcacc-toggled")) {
                    thatThis.slideClose(cb);
                }
                else {
                    thatThis.slideOpen(cb);
                    if (that.find(".zfcgac-gallery-item-wrapper:not(.swiper-initialized)")
                        .length > 0)
                        zfcgac.init();
                    if (that.find(".zfcgs-general-slider:not(.zfcgs-initialized)").length >
                        0)
                        zfcgs.init();
                    if ((that
                        .find(".zfcc-contact.zfcc-slider .zfcc-content-container")
                        .hasClass("swiper") &&
                        that.find(".zfcc-contact.zfcc-slider .zfcc-content-container:not(.swiper-initialized)").length > 0) ||
                        that.find(".zfcc-contact.zfcc-slider .zfcc-content-row:not(.slick-initialized)").length > 0)
                        zfcc.init();
                    if (that
                        .find(".zfcfsv-full-size-video > .zfcfsv-video-wrapper")
                        .hasClass("null"))
                        zfcfsv.initFullSizeVideo(that.find(".zfcfsv-full-size-video"));
                }
            }
            else if (cb) {
                cb();
            }
        };
    }
    static init() {
        try {
            $(".zfcacc-item").each(zfcacc.addSlideFunction);
            $(".zfcacc-title-content-wrapper")
                .off("click.zfcacc")
                .on("click.zfcacc", function () {
                this.parentNode.triggerSlide();
            });
            if (window.location.hash.length > 0 &&
                !window.location.hash.includes("#session_state"))
                if ($(window.location.hash).length > 0)
                    if ($(window.location.hash).attr("class").indexOf("zfcacc-item") != -1)
                        if ($(window.location.hash).find(".zfcacc-title-content-wrapper")
                            .length > 0)
                            $(window.location.hash)
                                .find(".zfcacc-title-content-wrapper")
                                .click();
        }
        catch (err) {
            console.log("Initalization failed: zfcacc.init() " + err.message);
        }
    }
}
try {
    zfUtils.onReady(zfcacc.init);
}
catch (err) {
    console.log("Initalization failed: zfcacc.init() " + err.message);
}
